module.exports = __webpack_public_path__ + "img/floor_UG2.405fce07.svg";